import { CacheResolverMap } from 'apollo-cache-inmemory';

const cacheRedirects: CacheResolverMap = {
  Query: {
    page: (_, args, { getCacheKey }) => getCacheKey({ __typename: 'WWS_Page', id: args.id }),
  },
  WWS_Page: {
    headlineItem: (_, args, { getCacheKey }) => getCacheKey({ __typename: 'WWS_HeadlineItem', id: args.id }),
    paragraphItem: (_, args, { getCacheKey }) => getCacheKey({ __typename: 'WWS_ParagraphItem', id: args.id }),
    personItem: (_, args, { getCacheKey }) => getCacheKey({ __typename: 'WWS_PersonItem', id: args.id }),
    storyItem: (_, args, { getCacheKey }) => getCacheKey({ __typename: 'WWS_StoryItem', id: args.id }),
    activityItem: (_, args, { getCacheKey }) => getCacheKey({ __typename: 'WWS_ActivityItem', id: args.id }),
    accommodationItem: (_, args, { getCacheKey }) => getCacheKey({ __typename: 'WWS_AccommodationItem', id: args.id }),
    transportationItem: (_, args, { getCacheKey }) =>
      getCacheKey({ __typename: 'WWS_TransportationItem', id: args.id }),
    basicItem: (_, args, { getCacheKey }) => getCacheKey({ __typename: 'WWS_BasicItem', id: args.id }),
    photoGalleryItem: (_, args, { getCacheKey }) => getCacheKey({ __typename: 'WWS_PhotoGalleryItem', id: args.id }),
    photoTimelineItem: (_, args, { getCacheKey }) => getCacheKey({ __typename: 'WWS_PhotoTimelineItem', id: args.id }),
    photoItem: (_, args, { getCacheKey }) => getCacheKey({ __typename: 'WWS_PhotoItem', id: args.id }),
    embedItem: (_, args, { getCacheKey }) => getCacheKey({ __typename: 'WWS_EmbedItem', id: args.id }),
    questionItem: (_, args, { getCacheKey }) => getCacheKey({ __typename: 'WWS_QuestionItem', id: args.id }),
    livestreamItem: (_, args, { getCacheKey }) => getCacheKey({ __typename: 'WWS_LivestreamItem', id: args.id }),
  },
};

export default cacheRedirects;
